<template>
    <div class="machine_config bg-dark">
     <div class="alert" role="alert" id="snackbar">
        <strong>Error:</strong> All fields are requred!!!
        </div>
       <div class="alert" role="alert" id="snackbar1">
        <strong>Success:</strong>Pulses/minute has been updated!!!
        </div>
        <form class="config">
          <div class="form-group">
            <label for="name">Mechine Name:</label>
            <input type="text" class="form-control" placeholder="" id="machineName" v-model="machineName" disabled>
          </div>

          <div class="form-group">
              <label for="position">Product:</label>            
              <select class="form-control" v-model="product" id="product">
                  <option disabled selected>Choose product</option>
                  <option v-for="product in products" :key="product.id">
                   {{ product.name }}
                  </option>
              </select>
          </div>
          <div class="form-group">
              <label for="position">MonitorInput:</label>            
              <select class="form-control" v-model="MonitorInput" id="input">
                  <option disabled selected>Choose input</option>
                  <option v-for="input in inputs" :key="input.id" :value="input.PacketType">
                   {{ input.Input }}
                  </option>
              </select>
          </div>

            <button type="button" class="btn-sm btn-info" @click="updateConfig()">Submit</button>
            <router-link tag="button" to="/Compression" class="btn-sm btn-danger">Back</router-link>
        </form>
    </div>
</template>
<script>
import http from '../../../services/http'
import { get } from 'jquery'
export default {
    data() {
      return {
      states: [
              'On',
              'Off'
            ],
        machineName: '',
        position: '',
        site: '',
        product: '',
        ramacDevice: '',
        machinesType: '',
        pulseConfig: '',
        threshold: '',
        comm_interval: '',
        machine_state: '',
        MonitorInput: '',
        inputs: [],
        products: []
      }
    },
    
    mounted() {
      this.getMachine()
      this.getAllProducts()
    },
    methods: {
      getMachine() {
        http.get('/api/machines/' + encodeURIComponent(this.$route.params.machineName))
            .then((res) => {
              this.machineName = res.data[0].machineName
              this.product = res.data[0].product
              this.MonitorInput = res.data[0].MonitorInput
              this.ramacDevice = res.data[0].ramacDevice
              this.pulseConfig = res.data[0].pulseConfig
              this.threshold = res.data[0].threshold
              this.state = res.data[0].state
              this.comm_interval = res.data[0].comm_interval
              this.product = res.data[0].product
              this.getAllInputs() // GET INPUTS
            })
            .catch(function (error) {
                console.log(error)
            })
      },

      getAllInputs() {
        http.get('/api/device-inputs')
        .then((res) => {
          this.inputs = res.data
        })
        .catch(function (error) {
            console.log(error)
        })
      },
      getAllProducts() {
          http.get('/api/products')
            .then((res) => {
              this.products = res.data
            })
            .catch(function (error) {
                console.log(error)
            })
      },

        updateConfig() {
            if (this.pulseConfig === '') {
              if (this.machineName == '') {
                document.getElementById("machineName").style.border = "1px solid red";
              }
              if(this.product == '') {
                document.getElementById("product").style.border = "1px solid red";
              }
             var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function(){ 
                x.className = x.className.replace("show", "");
             }, 1000);
         } else {
            //AUDIT LOG PARAMS
            let fullname_user = localStorage.getItem('fullname') 
            let user_action = 'Edit Configuration'
            let description = fullname_user +" changed configurations setting for " + this.machineName
            http.put('/api/machines/config', {
                ramacDevice: this.ramacDevice,
                pulseConfig: this.pulseConfig,
                threshold: this.threshold,
                comm_interval: this.comm_interval,
                product: this.product,
                MonitorInput: this.MonitorInput,
            })
            .then(() => {
               // console.log(res)
                var x = document.getElementById("snackbar1");
                x.className = "show";
                setTimeout(function(){ 
                x.className = x.className.replace("show", "");
             }, 500);

            setTimeout(() => {
             //this.$router.go(-1)
            }, 500)
            })
          }
        },

     getConfigs() {
      
     }   
    }
}
</script>

<style scoped>
.btn {
    margin-right: 10px;
}

input,
select {
    width: 50%;
    margin-left: 25%;
}

label {
  color: #bdb8d7;
}

button {
    margin: 10px;
}
.alert {
    width: 30%;
}

#snackbar {
	visibility: hidden;
	min-width: 250px;
    margin-left: -125px;
    text-align: center;
    background-color: #ff9966 !important;
	border-radius: 2px;
	padding: 5px;
	position: fixed;
	z-index: 1;
	left: 50%;
    top: 10px;
	font-size: 17px;
  }
  
  #snackbar.show {
	visibility: visible;
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }

#snackbar1 {
	visibility: hidden;
	min-width: 250px;
    margin-left: -125px;
    text-align: center;
    background-color: #5cff3b !important;
	border-radius: 2px;
	padding: 5px;
	position: fixed;
	z-index: 1;
	left: 50%;
    top: 10px;
	font-size: 17px;
  }
  
  #snackbar1.show {
	visibility: visible;
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }
</style>